import { Injectable, NgZone } from "@angular/core";
import { CanActivate, CanActivateChild, CanLoad, Route, UrlSegment, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from "@angular/router";
import { Observable } from "rxjs";
import { AuthService } from "src/app/core/services/auth.service";
import { ModalService } from "src/app/core/services/modal.service";
import { TranslateService } from "@ngx-translate/core";
import { Util } from "src/app/shared/helpers/util";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad {
  util = new Util();

  constructor(
    private router: Router,
    private authService: AuthService,
    private modal: ModalService,
    private translate: TranslateService,
    private zone: NgZone,
  ) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (!this.authService.hasSession()) {
      this.showErrMsg("NOTLOGIN");
      return false;
    }
    if (!this.authService.hasPermission(state.url)) {
      this.showErrMsg("NOACCESS");
      return false;
    }
    return true;
  }

  canActivateChild(next: ActivatedRouteSnapshot, state: RouterStateSnapshot):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return true;
  }

  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
    return true;
  }

  showErrMsg(msgKey: string) {
    this.util.removeSecureStorage("ACTIVE_MENU");
    this.translate.get("COMMON.ERROR").subscribe((message) => {
      if (msgKey === "NOTLOGIN") {
        this.zone.run(() => this.router.navigate(["/login"]));
      }
      if (msgKey === "NOACCESS") {
        this.modal.alert({
          content: message[msgKey],
          callback: () => {
            this.zone.run(() => this.router.navigate(["/main/home"]));
          },
        });
      }
    });
  }

}
